<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <h4>
        Oops! Você não tem permissão para estar aqui.
        <i class="far fa-smile text-warning"></i>
      </h4>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
export default {
  name: 'No-Permission',
};
</script>

<style lang="scss" scoped>
</style>
